import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  inviteButton: {
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.error.contrastText,
    heightt: "100%",
    border: "1px solid #DBDBDB",
    borderRadius: theme.spacing(1.25),
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
  },
}));

export default useStyles;
